import React from "react";
import "../../App.css";

export default function News() {
  return <h1 className="news">NOTÍCIAS</h1>;
}
